import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const couponsApi = createApi({
    reducerPath: 'coupons',
    baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_URL,
        prepareHeaders: (headers, { getState, endpoint }) => {
            const token = JSON.parse(localStorage.getItem('user')!)?.token;
            headers.set('Authorization', token);
            headers.set('Content-Type', 'application/json');
            return headers;
        },
        responseHandler: async (response) => {
            const data = await response.json();
            return {
                ...data,
                meta: {
                    status: response.status,
                },
            };
        },
    }),
    endpoints: (builder) => ({
        verifyCoupon: builder.query({
            query: ({ code, customer, item, type }) => {
                const params = new URLSearchParams();
                params.append('code', code);
                params.append('customer', customer);
                params.append('item', item);
                params.append('type', type);
                return `coupon-valid/?${params.toString()}`;
            },
        }),
        verifyCouponLocality: builder.mutation({
            query: ({ code, body }) => {
                const params = new URLSearchParams();
                params.append('code', code);
                return {
                    url: `coupon-valid-locality/?${params.toString()}`,
                    method: 'POST',
                    body: body,
                }
            }
        })
    }),
});

export const { useLazyVerifyCouponQuery, useVerifyCouponLocalityMutation } = couponsApi;